import { render, staticRenderFns } from "./CoachGroupYouth.vue?vue&type=template&id=2c492fb4&"
import script from "./CoachGroupYouth.vue?vue&type=script&lang=js&"
export * from "./CoachGroupYouth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports